import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import logo from '../images/logo.png';

const Footer = () => {
    return (
        <div className="bg-[#001827] py-8 text-[rgb(185,185,185)] text-sm w-full">
            <div className="flex justify-center">
                <div className="flex flex-col md:flex-row mt-1 justify-center w-[90%] text-left md:items-stretch items-center gap-6 md:gap-0">
                    <div className="flex flex-col flex-[2] items-center md:items-end">
                        <img src={logo} alt="CPCT Logo" width="60" />
                        <div className="mt-4 text-center md:text-right">
                            Baraza la Makanisa ya Kipentekoste Tanzania<br />(CPCT)
                        </div>
                    </div>

                    <div className="hidden md:block w-[1px] bg-blue-300 opacity-20 mx-6"></div>
                    <div className="block md:hidden h-[1px] w-full bg-blue-300 opacity-20 my-2"></div>

                    <div className="flex-[3] text-center md:text-left flex flex-col gap-2">
                        <p>P.O. Box 529 Dodoma, Tanzania</p>
                        <p>
                            Email: <a href="mailto:info@cpct.or.tz" className="hover:text-white transition-colors">info@cpct.or.tz</a> | <a href="mailto:thecpct@gmail.com" className="hover:text-white transition-colors">thecpct@gmail.com</a>
                        </p>
                        <p>Tel: <a href="tel:+255767558668" className="hover:text-white transition-colors">+255 767 558 668</a></p>

                        <div className="flex gap-5 mt-3 justify-center md:justify-start items-center">
                            <a href="https://facebook.com/thecpctz" title="The CPCT Tanzania on Facebook" target="_blank" rel="noreferrer"
                               className="hover:text-[#1877F2] transition-colors duration-200">
                                <FaFacebook size={24} />
                            </a>
                            <a href="https://instagram.com/thecpctz" title="@thecpctz on Instagram" target="_blank" rel="noreferrer"
                               className="hover:text-[#E4405F] transition-colors duration-200">
                                <FaInstagram size={24} />
                            </a>
                            <a href="https://youtube.com" title="CPCT TV on YouTube" target="_blank" rel="noreferrer"
                               className="hover:text-[#FF0000] transition-colors duration-200">
                                <FaYoutube size={24} />
                            </a>
                        </div>

                        <p className="mt-4 text-gray-500 text-xs">CPCT &copy; {new Date().getFullYear()}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
